<div class="spo-centered-button">
    <button i18n mat-flat-button color="primary" (click)="handleClick()" class="spo-font-color-white">CREATE INSTANT
        ROOM</button>
</div>